import {ApplicationParametersActions, EApplicationParametersActions} from "../../actions/application-parameters/application-parameters.actions";
import {IApplicationParametersState, ILanguageState, initialApplicationParametersState, initialLanguageState} from "../../state/application-parameters/application-parameters.state";
import {IAppParamData} from "../../models/application-parameters/application-parameters.interface";

export const languageReducers = (
  state = initialLanguageState,
    action: ApplicationParametersActions
):ILanguageState =>{
  switch (action.type) {
    case EApplicationParametersActions.SetLanguage:{
      return {
        ...state,
        availableLanguages: state.availableLanguages,
        currentLanguage: action.payload
      };
    }
    default:
      return state;
  }
};

export const applicationParametersReducers = (
  state = initialApplicationParametersState,
    action: ApplicationParametersActions
): IApplicationParametersState =>{
  switch (action.type) {

    case EApplicationParametersActions.SetOrganisation:
      return {
        ...state,
        selectedOrganisationCode: action.payload.code,
        //selectedOrganisationCodeList: [],
        selectedOrganisationLevel: action.payload.level

      };
    case EApplicationParametersActions.SetOrganisationList:
      return {
        ...state,
        //selectedOrganisationCode: '',
        selectedOrganisationCodeList: action.payload.list,
        selectedOrganisationLevel: action.payload.level ===''?state.selectedOrganisationLevel:action.payload.level

      };

    case EApplicationParametersActions.SetNomenclature:
      return {
        ...state,
        selectedNomenclatureCode: action.payload.code,
        //selectedNomenclatureCodeList:[],
        selectedNomenclatureLevel: action.payload.level,
      };
    case EApplicationParametersActions.SetNomenclatureList:
      return {
        ...state,
        //selectedNomenclatureCode: '',
        selectedNomenclatureCodeList: action.payload.list,
        selectedNomenclatureLevel: action.payload.level,
      };
    case EApplicationParametersActions.SetDate:
      return {
        ...state,
        selectedDateFrom: action.payload.from,
        selectedDateTo: action.payload.to,
        selectedDateLevel: action.payload.periodType
      };

    case EApplicationParametersActions.SetSupplier:
      return {
        ...state,
        selectedSupplierCode: action.payload
      };
    case EApplicationParametersActions.SetDatasourcePartyId:
      return {
        ...state,
        selectedDatasourcePartyId: action.payload
      };
    case EApplicationParametersActions.SetFinDepartment:
      return {
        ...state,
        selectedFinDepartment: action.payload
      };
      // OSA
    case EApplicationParametersActions.SetOsaIncidentSelection:
      return {
        ...state,
        selectedOsaIncidentSelection: action.payload
      };
    case EApplicationParametersActions.SetOsaIncidentKind:
      return {
        ...state,
        selectedOsaIncidentKind: action.payload
      };
    case EApplicationParametersActions.SetOsaIncidentType:
      return {
        ...state,
        selectedOsaIncidentType: action.payload
      };



    case EApplicationParametersActions.ClearAppParam:
      return {
        ...state,
        selectedReportParam: {
          lastParamCode: '',
          params: []
        }
      };
    case EApplicationParametersActions.SetAppParam:
      //todo: вынести всю логику в эффект

      //проверяем что такой параметр уже есть и он точно такойже

      const curParamValue:IAppParamData =  state.selectedReportParam.params.find(item => item.code === action.payload.code);
      let needUpdate = false;
      if (!curParamValue || JSON.stringify(curParamValue)!==JSON.stringify(action.payload)) {
        needUpdate = true;
      }
      if (action.payload.code === 'date') {
        needUpdate = true;
      }
      if (needUpdate) {
        const currentParametersList = state.selectedReportParam.params.filter(item => item.code !== action.payload.code);

        currentParametersList.push(action.payload);

        return {
          ...state,
          selectedReportParam: {
            lastParamCode: action.payload.code,
            params: currentParametersList
          }

        };
      } else {
        return state;
      }

      break;
    case EApplicationParametersActions.RemoveAppParam:
      return {
        ...state,
        selectedReportParam: {
          lastParamCode: state.selectedReportParam.lastParamCode,
          params: state.selectedReportParam.params.filter(item=>item.code!==action.payload)
        }
      };
    default:
      return state;

  }
};



